import React, { Component } from 'react'
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import _, { toNumber } from "lodash";
import moment from "moment";
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";

import Autocomplete from "../../../component/autocomplete";
import request from "../../../lib/requester";

class CreateProgram extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      success: '',
      error: [],
      Program_Company: '',
      Program_Refnumber: '',
      Program_Type: '',
      Program_Description: '',
      Program_Budgettype: '',
      Program_Assignmenttype: '',
      Program_Startdate: new Date(),
      Program_Enddate: new Date(),
      Program_Claimexp: new Date(),
      Program_Budget: '0',
      Program_Salestarget: '0',
      Program_Customerpphtype: '',
      Program_Pphrate: '',
      Program_Participant: '',
      Program_Participant_Name: [],
      Program_Notes: '',
      Participant_Total: 0,
      lovDocument: [],
      lovProgramMember: [],
      lovBudget: [],
      lovCompany: [],
      lovProgramType: [],
      lovPPhType: [],
      lovAssignment: ['One Time', 'Multiple'],
      documentList: [],
      docsContainer: [],
      productList: [{ item_id: "", item_desc: "", item_reff: "", item_budget: "" }],
      showParticipant: true,
      participant: {},
      fileContainer: {},
      user: JSON.parse(window.localStorage.getItem("is_user"))
    }
  }

  componentDidMount = () => {
    this.getProgramData()
  }

  getProgramData = () => {
    let url = '/api/traces_chd/v1/program/data-detail-program'
    let { id } = this.props.match.params;
    let param = {
      program_id: id
    }

    this.setState({ loading: true })
    request.postCHD(url, param, {
      success: function (response) {
        let { Program, Document, Attachment, Product, Participant } = response.data.data

        if (Program[0].status !== 'P') {
          this.props.history.push('/admin/program-chd/approval')
          return
        } else {
          this.setDefaultValueProgram(Program)
          this.setState({ 
            docsContainer: Document, 
            productList: Product, 
            fileContainer: (Attachment.length > 0) ? Attachment[0] : {},
            Program_Participant_Name: Participant,
            loading: false
          })
          this.getDataProgramType()
          this.getMasterData()
        }
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false })
      }.bind(this)
    })
  }

  setDefaultValueProgram = (Program) => {
    let data = Program.length > 0 ? Program[0] : {}
    this.setState({
      Program_Company: data.org_id || '',
      Program_Description: data.description || '',
      Program_Budget: ((data.budget) ? this.thousandSeparator(data.budget) : 0) || 0,
      Program_Refnumber: data.ref_number || '',
      Program_Type: data.program_type_id || '',
      Program_Budgettype: data.budget_type_id || '',
      Program_Assignmenttype: data.customer_assignment_type || '',
      Program_Salestarget: ((data.sales_target) ? this.thousandSeparator(data.sales_target) : 0) || 0,
      Program_Customerpphtype: data.pph_type || '',
      Program_Pphrate: data.pph_rate || '0',
      Program_Participant: data.program_member_id || '',
      Participant_Total: data.total_participant || 0,
      Program_Notes: data.notes || '',
      Program_Startdate: data.start_date ? new Date(data.start_date) : '',
      Program_Enddate: data.end_date ? new Date(data.end_date) : '',
      Program_Claimexp: data.claim_exp_date ? new Date(data.claim_exp_date) : ''
    })
  }

  getMasterData = () => {
    let url = '/api/traces_chd/v1/program/data-master'
    request.getCHD(url, {
      success: function (response) {
        let { Company, BudgetType, ProgramDocument, ProgramPPhType, ProgramMemberType } = response.data.data
        this.setState({
          lovCompany: Company,
          lovBudget: BudgetType,
          lovDocument: ProgramDocument,
          lovPPhType: ProgramPPhType,
          lovProgramMember: ProgramMemberType
        })
      }.bind(this),
      error: function (e) {
        console.log(e.message)
      }
    })
  }

  getDataProgramType = () => {
    let orgId = this.state.Program_Company
    if (!orgId || orgId.length === 0) {
      this.setState({ lovProgramType: [], Program_Type: '' })
      return
    }

    let url = '/api/traces_chd/v1/program/data-program?org_id=' + (orgId || '')
    request.getCHD(url, {
      success: function (response) {
        let { ProgramType } = response.data.data
        this.setState({
          lovProgramType: ProgramType
        })
      }.bind(this),
      error: function (e) {
        console.log(e.message)
      }
    })
  }

  showNotification = () => {
    if (this.state.success.length > 0) {
      return (
        <div className="alert alert-success" role="alert">
          <i className="fa fa-check" /> {this.state.success}
        </div>
      );
    } else if (this.state.error.length > 0) {
      return (
        <div className="alert alert-danger" role="alert">
          <ul>
            {this.state.error.map((item, index) => {
              return <li key={index}><i class="fas fa-exclamation-triangle" /> {item}</li>;
            })}
          </ul>
        </div>
      );
    }
  }

  renderLovBudget = () => {
    return (
      <select className="col-md-8 form-control" name="Program_Budgettype" disabled={true} value={this.state.Program_Budgettype} onChange={this.handleChangeInput.bind(this)}>
        <option value="">- Select Budget Type -</option>
        {
          this.state.lovBudget.map((item, index) => (
            <option value={item.budget_type_id}>{item.budget_type}</option>
          ))
        }
      </select>
    )
  }

  renderLovAssignment = () => {
    return (
      <select className="col-md-8 form-control" name="Program_Assignmenttype" disabled={true} value={this.state.Program_Assignmenttype} onChange={this.handleChangeInput.bind(this)}>
        <option value="">- Select Customer Assignment Type -</option>
        {
          this.state.lovAssignment.map((val, index) => (
            <option key={index} value={val}>{val}</option>
          ))
        }
      </select>
    )
  }

  renderLovCompany = () => {
    return (
      <select className="col-md-8 form-control" name="Program_Company" disabled={true} value={this.state.Program_Company} onChange={this.handleChangeInput.bind(this)}>
        <option value="">- Select Company -</option>
        {
          this.state.lovCompany.map((item, index) => (
            <option value={item.org_id}>{item.org_name}</option>
          ))
        }
      </select>
    )
  }

  renderLovProgramType = () => {
    return (
      <select className="col-md-8 form-control" name="Program_Type" value={this.state.Program_Type} disabled={true} onChange={this.handleChangeInput.bind(this)}>
        <option value="">- Select Program -</option>
        {
          this.state.lovProgramType.map((item, index) => (
            <option value={item.prog_type_id}>{item.program_name}</option>
          ))
        }
      </select>
    )
  }

  renderLovPPH = () => {
    return (
      <select className="col-md-8 form-control" name="Program_Customerpphtype" disabled={true} value={this.state.Program_Customerpphtype} onChange={this.handleChangeInput.bind(this)}>
        <option value="">- Select PPh Type -</option>
        {
          this.state.lovPPhType.map((item, index) => (
            <option value={item.pph_type}>{item.pph_type}</option>
          ))
        }
      </select>
    )
  }

  formProgram = () => {
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header bg-light font-size-title">
              Program
            </div>
            <div className="multi-collapse show" id="multiCollapseExample2">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Company</label>
                      {this.renderLovCompany()}
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Reff Number / IM</label>
                      <input type="text" className="form-control col-md-8" disabled={true} onChange={this.handleChangeInput.bind(this)} name="Program_Refnumber" value={this.state.Program_Refnumber} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Program Type</label>
                      {this.renderLovProgramType()}
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Program Description</label>
                      <input type="text" className="form-control col-md-8" disabled={true} name="Program_Description" onChange={this.handleChangeInput.bind(this)} value={this.state.Program_Description} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Budget Type</label>
                      {this.renderLovBudget()}
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Customer Assignment Type</label>
                      {this.renderLovAssignment()}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Start Date</label>
                      <div className="col-sm-3 pl-0">
                        <DatePicker
                          selected={this.state.Program_Startdate}
                          dateFormat="d-MMM-yyyy"
                          className="form-control"
                          popperPlacement="top-end"
                          onChange={this.handleStartDate}
                          disabled={true}
                        />
                      </div>
                      <label className="col-md-2 mt-1">End Date</label>
                      <div className="col-sm-3">
                        <DatePicker
                          selected={this.state.Program_Enddate}
                          dateFormat="d-MMM-yyyy"
                          className="form-control"
                          popperPlacement="top-end"
                          onChange={this.handleEndDate}
                          disabled={true}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Claim Exp Date</label>
                      <div className="col-md-3 pl-0">
                        <DatePicker
                          selected={this.state.Program_Claimexp}
                          dateFormat="d-MMM-yyyy"
                          className="form-control"
                          popperPlacement="top-end"
                          onChange={this.handleExpDate}
                          disabled={true}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Budget</label>
                      <input type="text" className="form-control col-md-8" disabled={true} name="Program_Budget" onChange={this.handleChangeInput.bind(this)} value={this.state.Program_Budget} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Sales Target</label>
                      <input type="text" className="form-control col-md-8" disabled={true} name="Program_Salestarget" onChange={this.handleChangeInput.bind(this)} value={this.state.Program_Salestarget} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Customer PPH Type</label>
                      {this.renderLovPPH()}
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">PPh Rate (%)</label>
                      <input type="number" className="form-control col-md-8" disabled={true} name="Program_Pphrate" onChange={this.handleChangeInput.bind(this)} value={this.state.Program_Pphrate} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    )
  }

  formDocument = () => {
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header bg-light">
              <a className="text-decoration-none text-dark font-size-title" data-toggle="collapse" href="#multiCollapseExample3" role="button" aria-expanded="true" aria-controls="multiCollapseExample3">Claim Documents <i className="fas fa-chevron-down font-size-small text-muted" /></a>
            </div>
            <div className="multi-collapse show" id="multiCollapseExample3">
              <div className="card-body">
                <div className="row">
                  {this.renderListDocument()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    )
  }

  formParticipant = () => {
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header bg-light">
              <a className="text-decoration-none text-dark font-size-title" data-toggle="collapse" href="#multiCollapseExample6" role="button" aria-expanded="true" aria-controls="multiCollapseExample6">Participants <i className="fas fa-chevron-down font-size-small text-muted" /></a>
            </div>
            <div className="multi-collapse show" id="multiCollapseExample6">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">Participants Type</label>
                      <div className="col-sm-8">
                        {this.renderLovProgramMember()}
                      </div>
                    </div>
                    <div className="form-group row">
                      <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">Participant</label>
                      {this.renderParticipant()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    )
  }

  formProduct = () => {
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header bg-light">
              <a className="text-decoration-none text-dark font-size-title" data-toggle="collapse" href="#multiCollapseExample5" role="button" aria-expanded="true" aria-controls="multiCollapseExample2">Products <i className="fas fa-chevron-down font-size-small text-muted" /></a>
            </div>
            <div className="multi-collapse show" id="multiCollapseExample5">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12">
                    <table className="table table-hover table-sm table-bordered">
                      <tbody>
                        <tr className="bg-info">
                          <th>ITEM DESC</th>
                          <th>ITEM BUDGET</th>
                        </tr>
                        {this.renderProduct()}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    )
  }

  renderParticipant = () => {
    return (
      <ul>
        { this.state.Program_Participant_Name.map((item, index) => (
          <li key={index}>{ item.participant }</li>
        ))}
      </ul>
    )
  };

  renderLovProgramMember = () => {
    return (
      <select className="form-control" name="Program_Participant" disabled={true} value={this.state.Program_Participant} onChange={this.handleChangeParticipant.bind(this)}>
        <option>- Select Participants -</option>
        {this.state.lovProgramMember.map((item, index) => (
          <option value={item.program_member_id} key={index}>
            {item.description}
          </option>
        ))}
      </select>
    );
  }

  setChecked = (item) => {
    let find = _.find(this.state.docsContainer, function (o) {
      return o.document_id === item.document_id;
    });
    return find ? true : false;
  };

  renderListDocument = () => {
    return this.state.lovDocument.map((item, index) => (
      <div className="col-md-4" key={index}>
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            defaultChecked={this.setChecked(item)}
            value={item.document_id}
            onClick={this.handleClickDocument.bind(this)}
            id="defaultCheck1"
            disabled={true}
          />
          <label className="form-check-label" htmlFor="defaultCheck1">
            {item.document_name}
          </label>
        </div>
      </div>
    ));
  }

  handleClickDocument = (e) => {
    let is_checked = e.target.checked;
    let docId = e.target.value;
    let { documentList } = this.state;
    if (is_checked) {
      documentList.push({ documentId: docId });
    } else {
      let getIndex = _.findIndex(documentList, function (o) {
        return parseInt(o.documentId) === parseInt(docId);
      });
      documentList.splice(getIndex, 1);
    }
    this.setState(documentList);
  };

  handleStartDate = (date) => {
    this.setState({ Program_Startdate: date });
  };

  handleEndDate = (date) => {
    this.setState({ Program_Enddate: date });
  };

  handleExpDate = (date) => {
    this.setState({ Program_Claimexp: date });
  };

  handleChangeInput = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    if (name === "Program_Budget" || name === "Program_Salestarget") {
      value = this.thousandSeparator(value);
    }

    if (name === "Program_Customerpphtype" && value === "Tidak Potong PPh") {
      this.setState({ Program_Pphrate: 0 });
    }

    this.setState({ [name]: value });
    let app = this;
    window.setTimeout(() => {
      if (name === "Program_Company") {
        app.getDataProgramType();
      }
      if (name === "Program_Customerpphtype" && value === "Tidak Potong PPh") {
        app.setState({ Program_Pphrate: 0 });
      }
    }, 100);
  };

  handleChangeParticipant = (e) => {
    let value = e.target.value;
    let { Participant_Total } = this.state
    this.setState({ 
      Program_Participant: value, 
      showParticipant: (value.length > 0) ? true : false,
      Participant_Total: (value.length > 0) ? Participant_Total : 0 
    });
    // this.handleChangeType(value);
  };

  handleChangeType = (value) => {
    let find = _.find(this.state.lovProgramMember, function (o) {
      return o.program_member_id === parseInt(value);
    });
    let type = find ? find.description : "";
    this.setState({ memberId: value, memberType: type });

    let { participant } = this.state;
    participant.customer_id = null;
    participant.participant = null;
    if (type === "Customer") {
      this.setState({ showParticipant: false });
    } else {
      this.setState({ showParticipant: true });
    }
  };

  onSelectProduct = (item, index) => {
    let { productList } = this.state;
    productList[index].item_id = item.value;
    productList[index].item_desc = item.text;
    this.setState(productList)
  };

  onChangeProductReff = (event) => {
    let value = event.target.value;
    let currentindex = event.target.attributes.getNamedItem("currentindex").value;
    let { productList } = this.state;

    productList[currentindex].item_reff = value;
    this.setState(productList)

    let app = this
  };

  onChangeProductBudget = (event) => {
    let value = event.target.value.length > 0 ? event.target.value : "";
    let currentindex = event.target.attributes.getNamedItem("currentindex").value;
    let { productList } = this.state;

    productList[currentindex].item_budget = this.thousandSeparator(value);
    this.setState(productList)
  };

  onChangeAutocomplete = (index, description) => {
    let container = [];
    let app = this;
    let principalCode = _.find(this.state.lovCompany, function (o) {
      return parseInt(o.org_id) === parseInt(app.state.Program_Company);
    });

    let param = {
      principalCode: principalCode ? principalCode.org_initial : "",
      itemDescription: description,
    };

    let { productList } = this.state
    productList[index].item_desc = description
    this.setState(productList)

    return new Promise((resolve) => {
      request.postOracle("/api/orafin/v1/product/list", param, {
        success: function (response) {
          var api_response = response.data.data;
          container = api_response.map((item, index) => {
            item.text = item.ITEM_DESCRIPTION;
            item.value = item.ITEM_ID;
            return item;
          });
          resolve(container);
        },
        error: function (e) {
          resolve([]);
        },
      });
    });
  };

  replicateProduct = () => {
    let { productList } = this.state;
    productList.push({
      item_id: "", // this.state.productID
      item_desc: "", // this.state.productDESC
      item_reff: "",
      item_budget: "",
    });
    this.setState(productList);
  };

  removeProduct = (index) => {
    if (this.state.productList.length === 1) {
      alert("You must have at least 1 product");
      return false;
    }
    let { productList } = this.state;
    productList.splice(index, 1);
    this.setState(productList)
  };

  renderAddProduct = () => {
    let app = this;
    let principalCode = _.find(this.state.lovCompany, function (o) {
      return parseInt(o.org_id) === parseInt(app.state.Program_Company);
    });

    return (
      <div className="form-group row">
        <div className="col-sm-4">
          <Autocomplete id="productDefine" onchange={this.onChangeAutocomplete.bind(this)} principalCode={principalCode} onselect={this.onSelectProduct.bind(this)} />
        </div>
        <div className="col-sm-2">
          <button type="button" onClick={this.replicateProduct.bind(this)} className="btn btn-success">+</button>{" "} &nbsp;
        </div>
      </div>
    );
  };

  renderProduct = () => {
    return this.state.productList.map((item, index) => (
      <tr key={index}>
        <td>{item.item_description}</td>
        <td>{(item.item_budget) ? this.thousandSeparator(item.item_budget) : 0}</td>
      </tr>
    ));
  };

  formNotes = () => {
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header bg-light font-size-title">
              Notes
            </div>
            <div className="multi-collapse show" id="multiCollapseExample7">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <textarea className="form-control" disabled={true} name="Program_Notes" rows={5} onChange={this.handleChangeInput.bind(this)} value={this.state.Program_Notes}></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    )
  }

  formAttachment = () => {
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header bg-light font-size-title">
              Attachments
            </div>
            <div className="multi-collapse show" id="multiCollapseExample7">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group row">
                      <div className="col-sm-12">
                        <Link to={{ pathname: this.state.fileContainer.path }} target="_blank">
                          {this.state.fileContainer.filename}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    )
  }

  formButton = () => {
    return (
      <div className="row mt-1">
        <div className="col-md-3">
          <button type="button" className="btn btn-primary btn-block" onClick={this.handleApprove.bind(this)}><i className="fa fa-check" />&nbsp; Approve Program</button>
        </div>
        <div className="col-md-3">
          <button type="button" className="btn btn-danger btn-block" onClick={this.handleReject.bind(this)}><i className="fa fa-times" />&nbsp; Reject Program</button>
        </div>
        <div className="col-md-3">
          <button type="button" className="btn btn-warning btn-block" onClick={() => { this.props.history.push('/admin/program-chd/approval') }}><i className="fa fa-arrow-left" />&nbsp; Back</button>
        </div>
      </div>
    )
  }

  uploadFile = (e) => {
    if (e.target.files.length === 0) {
      return false;
    }

    let files = e.target.files[0];
    // validation
    let filename = files.name;
    var fileExt = filename.split(".").pop();
    var allowedFile = [
      "jpg",
      "png",
      "jpeg",
      "gif",
      "doc",
      "docx",
      "xls",
      "xlsx",
      "csv",
      "pdf",
    ];
    if (allowedFile.indexOf(fileExt) < 0) {
      this.setState({ error: ["File extension not allowed"] });
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      return false;
    }

    const data = new FormData();
    data.append("myFile", files, files.name);
    this.setState({ loading: true });
    request.postnobodyCHD("/api/traces_chd/v1/util/upload-file", data, {
      success: function (response) {
        let data = response.data;
        this.setState({ fileContainer: data, loading: false });
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      },
    });
  };

  thousandSeparator = (value) => {
    if (!value || value.length === 0) {
      return false
    }
    value = value.toString().replace(/,/g, "").replace(/[^0-9.]/g, "");
    var parts = value.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  };

  removeSeparator = (value) => {
    if (!value || value.length === 0) {
      return
    }
    value = value.replace(/,/g, "").replace(/[^0-9.]/g, "");
    return value;
  };

  handleReject = () => {
    let url = '/api/traces_chd/v1/program/approve'
    let { id } = this.props.match.params;
    let param = {
      program_id: id,
      action: 'REJECT'
    }

    this.setState({ loading: true })
    request.postCHD(url, param, {
      success: function (response) {
        let { message } = response.data
        this.setState({ loading: false, success: message })
        window.scrollTo(0,0)

        let app = this
        window.setTimeout(() => {
          app.props.history.push('/admin/program-chd/approval')
        }, 3000)
      }.bind(this),
      error: function (e) {
        let message = e.response.data ? e.response.data.message : 'Failed to approve'
        this.setState({ loading: false, error: [] })
      }.bind(this)
    })
  }

  handleApprove = () => {
    let url = '/api/traces_chd/v1/program/approve'
    let { id } = this.props.match.params;
    let param = {
      program_id: id,
      action: 'APPROVE'
    }

    this.setState({ loading: true })
    request.postCHD(url, param, {
      success: function (response) {
        let { message } = response.data
        this.setState({ loading: false, success: message })
        window.scrollTo(0,0)

        let app = this
        window.setTimeout(() => {
          app.props.history.push('/admin/program-chd/approval')
        }, 3000)
      }.bind(this),
      error: function (e) {
        let message = e.response.data ? e.response.data.message : 'Failed to approve'
        this.setState({ loading: false, error: [] })
      }.bind(this)
    })
  }

  formValidation = () => {
    let error = [];

    let { productList } = this.state
    let totalAmountProduct = 0
    productList.forEach((item, index) => {
      totalAmountProduct += parseInt(this.removeSeparator(item.item_budget || 0))
    })

    if (this.state.Program_Company === '' || this.state.Program_Company.length === 0) {
      error.push('Principal is required')
    }
    if (this.state.Program_Description === '' || this.state.Program_Description.length === 0) {
      error.push('Description is required')
    }
    if (this.state.Program_Type === '' || this.state.Program_Type.length === '') {
      error.push('Program Type is required')
    }
    if (this.state.Program_Budgettype === '' || this.state.Program_Budgettype.length === 0) {
      error.push('Program Budget Type is required')
    }
    if (this.state.Program_Refnumber === '' || this.state.Program_Refnumber.length === 0) {
      error.push('Program Ref Number is required')
    }
    if (this.state.Program_Budget === '' || this.state.Program_Budget.length === 0) {
      error.push('Program Budget is required')
    }
    if (this.state.Program_Salestarget === '' || this.state.Program_Salestarget.length === 0) {
      error.push('Program Sales Target is required')
    }
    if (this.state.documentList.length === 0) {
      error.push("You must have at least 1 document");
    }
    if (this.state.Program_Participant === "") {
      error.push("Please Select Participants");
    }
    if (totalAmountProduct > 0 && totalAmountProduct !== parseInt(this.removeSeparator(this.state.Program_Budget))) {
      error.push('Total budget of products must be 0 or equal with budget program')
    }

    this.setState({ error: error })
    if (error.length > 0) {
      window.scrollTo(0, 0)
      return false
    } else {
      return true
    }
  }
  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12 col-sx-12">
                <div className="card card-info">
                  <div className="card-body">
                    {this.showNotification()}
                    <form className="form-horizontal">
                      {this.formProgram()}
                      {this.formDocument()}
                      {this.formParticipant()}
                      {this.formProduct()}
                      {this.formNotes()}
                      {this.formAttachment()}
                      {this.formButton()}
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    )
  }
}

export default CreateProgram